import { createContext, useState } from 'react';
import { SidebarAndModalContextProps, SidebarAndModalProviderProps } from './type';

export const SidebarAndModalContext = createContext<SidebarAndModalContextProps>(
  {} as SidebarAndModalContextProps
);

export const SidebarAndModalProvider = ({ children }: SidebarAndModalProviderProps) => {
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleDrawerMobile = () => {
    setOpen(!open);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <SidebarAndModalContext.Provider
      value={{
        open,
        openModal,
        handleDrawerMobile,
        handleDrawerOpen,
        handleDrawerClose,
        handleOpenModal,
        handleCloseModal,
      }}
    >
      {children}
    </SidebarAndModalContext.Provider>
  );
};
